import type { FaireProductEntity } from "../../entity_types/product";

export const p_mxvhpenabt: FaireProductEntity = {
  token: "p_mxvhpenabt",
  type: "product",
  name: "Lily Sweater Cami (2XS/S - 2M/L)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/1af95226feb8c0b072c63646509f6d07b562596858d3355ac51b1d606b1be699.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa0f66ae6e35036c707b53b38980591cfd0ac54ee981fb6dd9d0a558229e6279.jpeg",
    "https://cdn.faire.com/fastly/00ea98bbbb1b1b9da1750040cfbc1c5d56f7f7377680d25587738426007ab4d9.jpeg",
    "https://cdn.faire.com/fastly/41bff2bb56dbab29b62ba225f9f1ae7efb8b726b4586e56c5c526b6a0949eedf.jpeg",
    "https://cdn.faire.com/fastly/cc866c1b9bcb87fce2699c93491e6aa9663282da6eeb6ae3ca3f3f79d8d79328.jpeg",
    "https://cdn.faire.com/fastly/3b8f084a4f22b4c5140c21a45f0c63704d0aec3f261436a633bbf14140f56d00.jpeg",
  ],
  priceDollars: 176,
  description:
    'Why we made this?\n\nA playful study in texture. The Lily Sweater Cami features a unique knit with a soft, low-pile feel—reminiscent of a cotton-blend terry with a comfortable, easy stretch. Designed with a softened square neckline and contrast straps, this silhouette sits close to the body at a classic waist length. Pair it with the Long Arc Pants and sandals for a casual, effortless look.\n\nContents: \n\n70% Cotton, 27% Nylon, 3% Spandex\n\nMade in South Korea\n\n\n\nCare Instructions:\n\nHand wash in cold water\n\nTowel dry & lay flat to dry\n\n\n\nApproximate Measurements: \n\nXS/S: Length 19 1/2", Chest 12 1/2"\n\nM/L: Length: 20", Chest: 13" \n\n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip: 36" and wearing a size XS/S \n\n\n\nMSRP: $89 USD\n',
  tags: [],
  msrpDollars: 352,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:48.952Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
